import React, { useLayoutEffect } from "react";

import SaiBirthday from "../components/saibirthday/saibirthday";
import Footer from "../components/footer/footer";
import SathyaSaiMenu from "../components/navbarmenu/navmenu";
import BottomBanner from "../components/bottombanner/bottombanner";
import QuoteBanner from "../components/quotebanner/quotebanner";
import Menucardforallpage from "../components/menucardforallpage/menucardforallpage";

function SathyaSai100Birthday() {
    useLayoutEffect(() => {
     document.title = 'Sathya Sai 100th Birthday - Sri Sathya Sai Center of Milwaukee | ssscmke.org';
    }, []);
  return (
    <div className="SSE">
        <SathyaSaiMenu />
        <QuoteBanner />
        <SaiBirthday />
        <Menucardforallpage page="sathyasai100birthday"/>
        <BottomBanner />
        <Footer />
    </div>
  );
}
export default SathyaSai100Birthday;
